import { render, staticRenderFns } from "./TwoFactorAuthenticationPage.vue?vue&type=template&id=079ed56c"
import script from "./TwoFactorAuthenticationPage.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports